"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, ShieldCheck, Clock, Award } from "lucide-react";
const slides = [{
  id: 1,
  title: "Dr. Jonathan Smith, DDS",
  description: "Our lead implant specialist with over 15 years of experience in restorative dentistry. Dedicated to providing efficient, high-quality implant solutions.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617360/img/dentist-implants-specialist.png",
  ctaText: "View Implants",
  ctaLink: "/ImplantsPage",
  badgeText: "Dr. Sean Moghadam"
}, {
  id: 2,
  title: "Dr. Sarah Chen, DMD",
  description: "A specialist in high-end prosthetics and custom dentures. Dr. Chen focuses on creating comfortable, natural-looking smiles for every patient.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617360/img/denture-specialist-doctor.png",
  ctaText: "View Dentures",
  ctaLink: "/DenturesPage",
  badgeText: "Prosthetics Expert"
}, {
  id: 3,
  title: "Expert Clinical Team",
  description: "Our compassionate team in El Monte specializes in sedation and pain-free extractions, ensuring your comfort is always our top priority.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617360/img/dental-team-el-monte.png",
  ctaText: "Book Consultation",
  ctaLink: "/ContactUsPage",
  badgeText: "Sedation Certified"
}];
const features = [{
  id: 1,
  title: "Board Certified",
  icon: ShieldCheck
}, {
  id: 2,
  title: "20+ Yrs Experience",
  icon: Clock
}, {
  id: 3,
  title: "Quality Guarantee",
  icon: Award
}];
export default function Banner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section data-section-id="151189" id="meetourdoctors" ref={ref} className={`w-full bg-background text-foreground relative overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <Carousel opts={{
      loop: true,
      align: "start"
    }} className="w-full">
        <CarouselContent>
          {slides.map((slide, index) => <CarouselItem data-index={index} key={slide.id} className="relative w-full">
              {}
              <div className="absolute inset-0 w-full h-full">
                <img src={slide.image} alt={slide.title} className="w-full h-full object-cover object-center" />
                {}
                <div className="absolute inset-0 bg-foreground/20 mix-blend-multiply" />
              </div>

              {}
              
            </CarouselItem>)}
        </CarouselContent>
        
        {}
        <div className="hidden md:block absolute bottom-12 right-12 lg:right-24 z-10">
          <div className="flex gap-3 bg-background/90 backdrop-blur-md p-2 rounded-full border border-border/40 shadow-xl">
            <CarouselPrevious className="relative inset-0 translate-y-0 translate-x-0 h-12 w-12 bg-background text-foreground hover:bg-primary hover:text-primary-foreground border-none shadow-sm transition-all duration-300" />
            <CarouselNext className="relative inset-0 translate-y-0 translate-x-0 h-12 w-12 bg-background text-foreground hover:bg-primary hover:text-primary-foreground border-none shadow-sm transition-all duration-300" />
          </div>
        </div>
      </Carousel>
    </section>;
}